import { useContext, useMemo } from 'react'
import CustomSelect from '@/shared/components/custom-select'
import { NewContractContext } from './context'
import { toOptions } from '@/utils'
import { useFormikContext } from 'formik'
import { ManagmentSelector } from '@/shared/selectors'

export const AccountContactForm = () => {
  // context
  const { users } = useContext(NewContractContext)

  const userOptions = useMemo(() => {
    return toOptions({ data: users })
  }, [users])

  const { values, setFieldValue } = useFormikContext()

  return (
    <>
      <ManagmentSelector
        value={values.account_managment_id}
        onChange={(opt) => setFieldValue('account_managment_id', opt?.value || null)}
        required
      />

      <CustomSelect
        required
        placeholder="Administrador de contrato"
        options={userOptions}
        onChange={({ value }) => setFieldValue('user_id', value)}
        value={
          userOptions.find(
            (user) =>
              values.user_id === user.value
          ) || []
        }
      />

    </>
  )
}
